import {
  getSpecificPageVisibleItems,
  getStoreLogo,
  getAddressDetails,
  getActiveSocialMedia,
  getFooterRightReservedtext,
} from '../../utils/commonGetterFunction';
import { FooterDesktopContainer } from '../Footer2.styled';

const FooterDesktop = (props) => {
  const { footerState, store, propStyle, handleLogoClick } = props;
  return (
    <FooterDesktopContainer
      themeBackground={propStyle}
      className="footerDesktopContainer"
    >
      <div className="left-container">
        <div className="logo-container">
          {getStoreLogo(footerState?.footerElements, handleLogoClick)}
        </div>
        {getAddressDetails(footerState?.footerElements)}
      </div>
      <div className="middle-container">
        {getSpecificPageVisibleItems(footerState?.footerElements)}
      </div>
      <div className="right-container">
        {getActiveSocialMedia(store)}
        {getFooterRightReservedtext()}
      </div>
    </FooterDesktopContainer>
  );
};

export default FooterDesktop;
